//= ../../../bower_components/jquery-3.1.1.min.js
$(function(){